import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';

export default class GoogleAd extends PureComponent {

  // Tell google that there's a new ad on the page. Do this
  // in `componentDidMount` because the element needs to be
  // on the page for google to do its magic.
  componentDidMount() {

    // Delay ad display to prevent some google errors as well as prioritize our own code execution
    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 100);
  }

  render() {
    const { className } = this.props;

    return [
      <Helmet key="googlead-helmet">
        <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
      </Helmet>,
      <ins
        key="googlead-googleadsense"
        className={`adsbygoogle ${className}`}
        data-ad-client="ca-pub-7908993773401181"
        data-ad-format="auto"
        data-ad-slot="7634290200"
      />
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleAd/index.jsx